import minimizedWindowsContext from './MinimizedWindowsContext';

// Returns the dock context, or `undefined` when no MinimizedWindowsProvider is
// mounted above the caller. Callers use the empty result to skip the minimize
// behaviour entirely.
const useMinimizedWindows = () => minimizedWindowsContext.useContextOptional();

export default useMinimizedWindows;
